module.exports = __webpack_public_path__ + "static/transfer_request2-6a522b267c75be7b908797d0a06168ac.png";